/* eslint-disable react-hooks/rules-of-hooks */
import {SharedStateTarget} from './callbacks';
import {shouldShowWheelchairAccessibility} from 'data/apps/config';

const SHOW_ACCESSIBILITY_INFO = new SharedStateTarget(shouldShowWheelchairAccessibility);
export const useShouldShowWheelchairAccessibilityInfoState = () => SHOW_ACCESSIBILITY_INFO.useSharedState()
